import Spinner from './Spinner/Spinner'

const DashboardLoader = (): JSX.Element => (
  <div className="flex justify-center m-auto my-4 place-self-center">
    <Spinner />
  </div>
)

export default DashboardLoader
